import Button from "../Button";
import classNames from "./MediaPreviewErrorDialog.module.css";
import RadixDialog from "./RadixDialog";
import permissionsImg from "../../../assets/tutorials/permissions.webp";

function MediaPreviewErrorDialog(props: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <RadixDialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title={"Something is wrong with your camera or microphone"}
      contentClassName={classNames.MediaPreviewErrorDialog}
      content={
        <>
          <div>
            <h3>
              To use real-time translation, Langfinity requires access to your
              microphone and/or camera.
            </h3>
            <h3>If you accidentally blocked access, follow these steps:</h3>
            <ul>
              <li>
                <h3>Click the lock icon in the address bar</h3>
              </li>
              <li>
                <h3>Find Camera and Microphone settings and select Allow</h3>
              </li>
              <li>
                <h3>Refresh the page to apply changes</h3>
              </li>
            </ul>
          </div>
          <img src={permissionsImg} alt="Enable media permissions" />
          <Button onClick={() => props.onOpenChange(false)}>Continue</Button>
        </>
      }
    />
  );
}

export default MediaPreviewErrorDialog;
